{{ permission.description }}
@if (permission.restrictedBy.length > 0) {
  <a href="javascript: void(0)" (click)="toggleRestrictedVisibility(permission)">(Restricted)</a>
  <button
    title="Toggle visibility of restricted entities"
    type="button"
    [displayType]="buttonDisplayType.Icon"
    [size]="buttonSize.Small"
    ftrButton
    ftrStopPropagation
    (click)="toggleRestrictedVisibility(permission)"
  >
    <ftr-icon
      [icon]="permission.isExpanded ? 'KeyboardArrowUp' : 'KeyboardArrowDown'"
      color="GreyLight"
      align="Middle"
      [interactive]="true"
    >
    </ftr-icon>
  </button>
  @if (permission.isExpanded) {
    <div class="permissions-list__permission-restrictions">
      @for (entry of permission.restrictedBy; track trackRestrictionBy($index, entry)) {
        <div>
          <p>
            <strong> {{ entry.entityTypeVocabbed | titlecase }} ({{ entry.entityNames.length }}) </strong>
          </p>
          <ftr-collapsible-list
            expandText="View all {{ entry.entityTypeVocabbed | titlecase }}"
            collapseText="Collapse all {{ entry.entityTypeVocabbed | titlecase }}"
            [items]="entry.entityNames"
            [trackBy]="trackNameBy"
            [numberOfItemsToShow]="10"
          ></ftr-collapsible-list>
        </div>
      }
    </div>
  }
}
